/*
  HOOK: useAllArtistsCello
  PURPOSE: A hook to run a static query to retrieve all Artists who play Cello
*/
import { useStaticQuery, graphql } from 'gatsby'

const useAllArtistsCello = () => {
  const { allCosmicjsArtists } = useStaticQuery(
    graphql`
      query ALL_ARTISTS_CELLO {
        allCosmicjsArtists(
          filter: { metadata: { artist_categories: { eq: "Cello" } } }
        ) {
          nodes {
            id
            slug
            title
            metadata {
              artist_title
              artist_summary
              artist_image {
                url
                imgix_url
              }
            }
          }
        }
      }
    `,
  )

  return allCosmicjsArtists.nodes
}

export default useAllArtistsCello
